import React, { useState } from 'react'
import { Volume2, Loader2, AlertTriangle } from 'lucide-react'
import { useStartNarration, useNarrationStatus } from '../hooks/useResearch'
import { narrationAudioUrl } from '../services/researchApi'

// "Listen" control for an answer/synthesis. Starts a TTS job and shows an audio
// player when ready, or a clear message if the provider isn't configured/funded.
export default function ListenButton({ text, language = 'en-US', provider = 'elevenlabs' }) {
  const start = useStartNarration()
  const [jobId, setJobId] = useState(null)
  const status = useNarrationStatus(jobId, !!jobId)
  const state = status.data?.status

  const onListen = () => {
    if (!text || !text.trim()) return
    setJobId(null)
    start.mutate(
      { text, language, provider, title: 'answer' },
      { onSuccess: (r) => setJobId(r.job_id) }
    )
  }

  const working = start.isPending || (jobId && state !== 'completed' && state !== 'failed' && state !== 'cancelled')
  const failed = state === 'failed' || start.isError

  if (state === 'completed') {
    return (
      <audio
        controls
        src={narrationAudioUrl(jobId)}
        className="h-9 w-full max-w-md"
      />
    )
  }

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={onListen}
        disabled={working || !text}
        className="inline-flex items-center gap-1.5 px-3 h-8 rounded-lg text-xs font-medium border border-gold/50 text-gold-deep hover:bg-gold/10 disabled:opacity-50 dark:text-gold transition"
      >
        {working ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Volume2 className="w-3.5 h-3.5" />}
        {working ? 'Synthesizing…' : 'Listen'}
      </button>
      {failed && (
        <span className="inline-flex items-center gap-1 text-xs text-red-600 max-w-md truncate" title={status.data?.error || start.error?.message}>
          <AlertTriangle className="w-3.5 h-3.5 shrink-0" />
          {(status.data?.error || start.error?.message || 'Narration failed').slice(0, 80)}
        </span>
      )}
    </div>
  )
}
